class RewardPoints {
    // Membership -done
    static MEMBER_SIGNUP = 1500;
    static MEMBER_ADD_TYPE = "memberAdd";

    static ADD_TO_MEMBERS = 500;
    static ADD_TO_MEMBERS_TYPE = "memSave";

    static ADD_TO_NON_MEMBERS = 250;
    static ADD_TO_NON_MEMBERS_TYPE = "nonMemSave";

    // Profile Activities
    static LIKE = 250;
    static LIKE_TYPE = "like";

    static CALL = 50;
    static CALL_TYPE = "call";

    static WHATSAPP_CONTACT = 50;
    static WHATSAPP_CONTACT_TYPE = "whatsapp";

    static WEBSITE_LINK_VISIT = 200;
    static WEBSITE_LINK_VISIT_TYPE = "websiteVisit";

    static SOCIAL_LINK_VISIT = 100;
    static SOCIAL_LINK_VISIT_TYPE = "socialMedia";
    static SOCIAL_LINK_VISIT_TYPE_FB = "fb";
    static SOCIAL_LINK_VISIT_TYPE_LI = "li";
    static SOCIAL_LINK_VISIT_TYPE_YT = "yt";
    static SOCIAL_LINK_VISIT_TYPE_IG = "ig";
    static SOCIAL_LINK_VISIT_TYPE_X = "x";
    
    static PRODUCT_VIEW = 100;
    static PRODUCT_VIEW_TYPE = "productView";

    static PDF_DOWNLOAD = 200;
    static PDF_DOWNLOAD_TYPE = "pdf";

    static PROFILE_VIDEO = 150;
    static PROFILE_VIDEO_TYPE = "profileVideo";

    // Rating Stars
    static RATING = {
        STAR_1: 50,
        STAR_2: 100,
        STAR_3: 150,
        STAR_4: 200,
        STAR_5: 250,
    };
    static RATING_TYPE = "rating";

    // Redeem Offers
    static REDEEM_OFFER = 300;
    static REDEEM_OFFER_TYPE = "redeemPoint";

}
module.exports = RewardPoints;